import * as React from "react";
import type { SVGProps } from "react";
import PropTypes from 'prop-types';
/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string;
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number;
  alt?: string;
}
function IconChevronRightDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M8.845 5.47a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 0 1-1.06-1.06l5.47-5.47-5.47-5.47a.75.75 0 0 1 0-1.06" clipRule="evenodd" /></svg></>;
}
IconChevronRightDefault.propTypes = ({
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
} as PropTypes.ValidationMap<Props>);
export default IconChevronRightDefault;